import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { isBuildingChatEnabled, resolveBuildingList } from '../helper/chat';

// useChatEnabled is true when the selected building, or any in-scope building, has chat on.
export const useChatEnabled = () => {
  const globalBuildingId = useSelector((state) => Number(state.building?.globalBuildingId) || 0);
  const globalSelectedBuilding = useSelector((state) => state.building?.globalSelectedBuilding);
  const allBuildings = useSelector((state) => state.building?.allBuildings);
  const buildings = useSelector((state) => state.building?.buildings);

  return useMemo(() => {
    const list = resolveBuildingList(allBuildings, buildings);
    if (globalBuildingId > 0) {
      const fromList = list.find((building) => Number(building.id) === globalBuildingId);
      const selected =
        Number(globalSelectedBuilding?.id) === globalBuildingId ? globalSelectedBuilding : fromList;
      return isBuildingChatEnabled(selected) || isBuildingChatEnabled(fromList);
    }
    return list.some(isBuildingChatEnabled);
  }, [globalBuildingId, globalSelectedBuilding, allBuildings, buildings]);
};
